module.exports = __webpack_public_path__ + "static/media/shower-en-suite.1d75df0a.png";